import React from "react";

import { Registration } from "../features/auth";

const RegistrationPage = () => {
  return <Registration />;
};

export default RegistrationPage;
